module.exports = __webpack_public_path__ + "img/recetteGestion.a4c3da1b.png";